/**
 * Built-in permission defaults per role (mirrors backend seed / rolePermissionDefaults.js).
 * Used when /permissions/me is unavailable or returns no grants yet.
 */

export const ERP_PERMISSION_NAMES = [
  'tab_erp', 'tab_accounting', 'tab_vendors', 'tab_buying', 'tab_crm_pipeline', 'tab_projects',
  'erp_accounts_view', 'erp_accounts_manage',
  'erp_journals_view', 'erp_journals_manage', 'erp_journals_post',
  'erp_reports_read', 'erp_reports_export',
  'erp_payments_view', 'erp_payments_manage',
  'erp_vendors_view', 'erp_vendors_manage',
  'erp_bills_view', 'erp_bills_manage',
  'erp_vendor_quote_view', 'erp_vendor_quote_manage',
  'erp_vendor_po_view', 'erp_vendor_po_manage',
  'erp_buying_approve', 'erp_buying_workflow_manage',
  'erp_selling_view', 'erp_selling_manage',
  'crm_pipeline_view', 'crm_pipeline_manage',
  'erp_projects_view', 'erp_projects_manage',
  'erp_companies_manage', 'erp_sensitive_reveal',
];

export const ERP_CONSULTANT_PERMISSIONS = [
  'tab_erp', 'tab_accounting', 'tab_vendors', 'tab_buying', 'tab_crm_pipeline', 'tab_projects',
  'erp_accounts_view',
  'erp_journals_view', 'erp_journals_manage',
  'erp_reports_read',
  'erp_payments_view', 'erp_payments_manage',
  'erp_vendors_view', 'erp_vendors_manage',
  'erp_bills_view', 'erp_bills_manage',
  'erp_vendor_quote_view', 'erp_vendor_quote_manage',
  'erp_vendor_po_view', 'erp_vendor_po_manage',
  'erp_selling_view', 'erp_selling_manage',
  'crm_pipeline_view', 'crm_pipeline_manage',
  'erp_projects_view', 'erp_projects_manage',
];

export const ALL_PERMISSION_NAMES = [
  'tab_dashboard', 'tab_jobs', 'tab_resumes', 'tab_matches', 'tab_candidates',
  'tab_timesheets', 'tab_crm', 'tab_settings', 'tab_register', 'tab_metadata',
  'tab_job_scanner', 'tab_email_queue', 'tab_ai_watch', 'tab_users', 'tab_services', 'tab_customers', 'tab_requisitions', 'tab_orders', 'tab_product_analytics', 'tab_board',
  ...ERP_PERMISSION_NAMES,
  'job_view', 'job_create', 'job_edit', 'job_delete',
  'user_view', 'user_create', 'user_edit', 'user_delete',
  'candidate_view', 'candidate_create', 'candidate_edit', 'candidate_delete', 'candidate_assign',
  'timesheet_view', 'timesheet_create', 'timesheet_approve',
  'group_manage', 'permission_manage', 'email_manage', 'scanner_manage', 'ai_matching_manage',
  'kpi_manage', 'view_all_data',
  'service_view', 'service_manage', 'service_enroll', 'service_finance_view', 'service_finance_manage',
  'service_sales_view', 'service_sales_manage',
  'service_customers_view', 'service_customers_manage',
  'requisition_view', 'requisition_manage', 'requisition_approve', 'requisition_workflow_manage',
  'order_view', 'order_manage', 'order_sign',
  'board_view', 'board_manage', 'board_share',
  'booking_manage',
];

export const ROLE_PERMISSION_DEFAULTS = {
  admin: ALL_PERMISSION_NAMES,
  consultant: [
    'tab_dashboard', 'tab_jobs', 'tab_matches', 'tab_candidates', 'tab_timesheets', 'tab_crm',
    'tab_settings', 'tab_register', 'tab_services', 'tab_customers', 'tab_requisitions', 'tab_orders', 'tab_board',
    ...ERP_CONSULTANT_PERMISSIONS,
    'job_view', 'job_create', 'job_edit', 'job_delete',
    'candidate_view', 'candidate_edit',
    'timesheet_view', 'timesheet_create',
    'service_view', 'service_enroll', 'service_finance_view',
    'service_sales_view', 'service_sales_manage',
    'service_customers_view', 'service_customers_manage',
    'requisition_view', 'requisition_manage',
    'order_view', 'order_manage', 'order_sign',
    'board_view', 'board_manage', 'board_share',
    'booking_manage',
    'kpi_manage',
  ],
  candidate: [
    'tab_dashboard', 'tab_jobs', 'tab_resumes', 'tab_matches', 'tab_settings', 'tab_services', 'tab_board', 'tab_crm',
    'job_view', 'service_view', 'board_view',
    'kpi_manage',
  ],
  external: [],
};

export function getBuiltinRolePermissions(role) {
  const names = ROLE_PERMISSION_DEFAULTS[role] || [];
  const map = {};
  for (const name of names) {
    map[name] = true;
  }
  return map;
}
